"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (react_1.default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24" },
        react_1.default.createElement("path", { fill: color, d: "M10 15.586L6.707 12.293 5.293 13.707 10 18.414 19.707 8.707 18.293 7.293z" })));
};
exports.default = CheckIcon;
